/**
 * Make a user's file name safe to use inside a Supabase Storage object key.
 *
 * WHY THIS EXISTS: Storage rejects keys with characters outside a small ASCII
 * set ("Invalid key"). Real file names routinely carry them — macOS screenshot
 * names put a NARROW NO-BREAK SPACE (U+202F) before "AM"/"PM", and accented or
 * non-Latin names are common. The key only has to be unique and valid; the
 * human name travels separately in `files.name`, which is what every grid and
 * download shows. So the key can be lossy.
 *
 * Rule: decompose accents (é → e), then replace every run of characters
 * outside `[A-Za-z0-9._-]` with a single `_`, trim leading/trailing `_`/`.`,
 * and cap the length (the extension is kept). An empty result becomes `file`.
 *
 * Shared by apps/web (every browser upload) and available to apps/api. Deno
 * edge functions cannot import this package, so
 * `supabase/functions/_shared/storageKey.ts` is a twin — keep the two rules
 * identical (both test files pin the same example names).
 */
const MAX_LENGTH = 120;
export function storageSafeFileName(name) {
    const ascii = name.normalize("NFKD").replace(/[\u0300-\u036f]/g, "");
    let safe = ascii.replace(/[^A-Za-z0-9._-]+/g, "_").replace(/^[_.]+|[_.]+$/g, "");
    if (!safe)
        return "file";
    if (safe.length > MAX_LENGTH) {
        const dot = safe.lastIndexOf(".");
        const ext = dot > 0 && safe.length - dot <= 10 ? safe.slice(dot) : "";
        safe = safe.slice(0, MAX_LENGTH - ext.length) + ext;
    }
    return safe;
}
//# sourceMappingURL=storageKey.js.map